export class SelfassementSummary {
  id: number;
  rulebookRuleID: string;
  libraryName: string;
  title: string;
  geography: string;
  country: string;
  regulator: string;
  effectiveDate: string;
  ruleBook: string;
  part: string;
  owner: string;
  title1: string;
  title2: string;
  title3: string;
  title4: string;
  title5: string;
  ruleID: string;
  regulatoryRuleFullRequirement: string;
  hyperlink: string;
  versionNumber: number;
  userId: string;
  userName: string;
  jurisdiction: string;
  jurisdictionId: number;
  isRecordTime: boolean;
  timeSpent: number;
  isSendNotification: boolean;

  constructor() {
    this.id = 0;
    this.rulebookRuleID = '';
    this.libraryName = '';
    this.title = '';
    this.geography = '';
    this.country = '';
    this.regulator = '';
    this.effectiveDate = '';
    this.ruleBook = '';
    this.part = '';
    this.owner = '';
    this.title1 = '';
    this.title2 = '';
    this.title3 = '';
    this.title4 = '';
    this.title5 = '';
    this.ruleID = '';
    this.regulatoryRuleFullRequirement = '';
    this.hyperlink = '';
    this.versionNumber = 0;
    this.userId = '';
    this.userName = '';
    this.jurisdiction = '';
    this.jurisdictionId = 0;
    this.isRecordTime = false;
    this.timeSpent = 0;
    this.isSendNotification = false;
  }
}
